import React, { useEffect } from 'react';
import { useDemo } from '../../state/DemoContext';
import './toast.css';

const Toast = ({ message, type = 'success', duration = 5000 }) => {
  const { actions } = useDemo();

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        actions.hideToast();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, actions]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      default:
        return '✓';
    }
  };

  return (
    <div className={`jo-xyz-demo-toast jo-xyz-demo-toast--${type} jo-xyz-demo-fade-in`}>
      <div className="jo-xyz-demo-toast__content">
        <div className="jo-xyz-demo-toast__icon">
          {getIcon()}
        </div>
        <div className="jo-xyz-demo-toast__message">
          {message}
        </div>
        <button
          className="jo-xyz-demo-toast__close"
          onClick={actions.hideToast}
          aria-label="Close notification"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Toast;
